import { useSetAtom } from 'jotai'
import { useSetRecoilState } from 'recoil'
import { internalGooglePlaceId, selectedLocationId } from 'src/atoms/search'
import { searchEntity } from 'src/v2/state/core'

export const useMapExplorerChoice = () => {
  const setSearchEntity = useSetAtom(searchEntity)
  const setLocationId = useSetRecoilState(selectedLocationId)
  const setGooglePlaceId = useSetRecoilState(internalGooglePlaceId)

  const chooseLocation = (locationId: string) => {
    setLocationId(locationId)
    setSearchEntity({ ids: { 'am-loc': locationId } })
  }

  const chooseAddress = (placeId: string) => {
    setGooglePlaceId(placeId)
    setSearchEntity({ ids: { google: placeId } })
  }

  const clearChoice = () => {
    setLocationId(undefined)
    setGooglePlaceId(undefined)
    setSearchEntity({ ids: {} })
  }

  return {
    chooseLocation,
    chooseAddress,
    clearChoice,
  }
}
